/**
 * configureFontAwesome
 * Load FontAwesome styles from a CSS asset (allowed by style-src 'self') and
 * disable runtime <style> injection, which Firebase CSP blocks after the
 * security-scan hash-based style-src update.
 */
import { config } from "@fortawesome/fontawesome-svg-core"
import "@fortawesome/fontawesome-svg-core/styles.css"

config.autoAddCss = false
